<template>
    <v-container>
        <v-row>
            <v-col sm="9">
                <h1 class="title font-weight-light">
                    <v-icon @click="onCancel">mdi-arrow-left-circle</v-icon>
                    Form Detail
                    <span :class="`color-circle-s ml-1 ${getStatusColor(item.StatusId)}`"></span>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-chip v-on="on" class="ml-2 f-b" small :color="item.PublishedVer ? 'success' : 'warning'" label>
                                v.{{item.PublishedVer || 0}}
                            </v-chip>
                        </template>
                        <div v-if="item.PublishedVer">Form version <b>{{item.PublishedVer}}</b> is published and live.</div>
                        <div v-if="item.PublishedVer && item.PublishedVer !== item.Version">Version <b>{{item.Version}}</b> is ready to be published.</div>
                        <div v-if="!item.PublishedVer">This form is unpublished.</div>
                    </v-tooltip>
                    <span class="subtitle-1 ml-2 mr-2">{{item.Name}}</span>
                    <v-icon>{{ item.Icon }}</v-icon>
                </h1>
            </v-col>
            <v-col sm="3" class="text-right">
                <span class="subtitle-2">{{ editLangName }}</span>
                <!-- <v-chip class="ml-2" color="primary" label dark>
                    <v-icon left>mdi-translate</v-icon>
                    <span class="text-uppercase">{{ editLang }}</span>
                </v-chip> -->
                <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" class="ml-2" dark v-bind="attrs" v-on="on">
                            <v-icon left>mdi-translate</v-icon>
                            {{ editLang }}
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-for="lang in languages" :key="lang.id" @click="onLanguageChange(item)">
                            <v-list-item-title>{{ lang.text }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-row class="mt-0">
            <v-col sm="12">
                <v-card :loading="isBusy" class="w-1024">
                    <v-container>
                        <v-tabs>
                            <v-tab>Detail</v-tab>
                            <v-tab>Questions</v-tab>
                            <!-- <v-tab>Style</v-tab> -->
                            <v-tab>Messages</v-tab>
                            <v-tab>Properties</v-tab>
                             <v-tab>Relationship</v-tab>
                            <!-- Detail -->
                            <v-tab-item class="mt-3 mb-3">
                                <v-form ref="formDetail" v-model="isValidDetail">
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-text-field
                                                ref="name"
                                                label="Form Name"
                                                v-model="item.Name"
                                                counter="100"
                                                minlength="2"
                                                maxlength="100"
                                                autofocus
                                                clearable
                                                :loading="isSurveyBusy"
                                                :error="nameError"
                                                :error-messages="nameErrors"
                                                :rules="[rules.required, rules.min, rules.startChar, rules.avail]"
                                                @blur="onBlur">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-select ref="status" label="Status" v-model="item.StatusId" :items="statusOptions" item-text="text" item-value="id" :rules="[rules.required]"></v-select>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-text-field label="Table Name" v-model="item.Table" hint="System generated and immutable" :loading="isSurveyBusy" persistent-hint disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-select label="Exposure" v-model="item.Exposure" :items="exposureOptions" v-on:change="updateLink" item-text="text" item-value="id" :rules="[rules.required]"></v-select>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-text-field label="Last Update" v-model="item.UpdateDateString" persistent-hint disabled></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-text-field label="URL" v-model="item.Link" hint="System generated" append-icon="mdi-content-copy" @click:append="copyLink" persistent-hint readonly></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller" v-if="QrCode !== ''">
                                        <v-col sm="12">
                                            <v-img label="QRCode" :src="`${QrCode}`" max-width="124" max-heigth="124">
                                                <template v-slot:placeholder>
                                                <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular
                                                    indeterminate
                                                    color="grey lighten-5"
                                                ></v-progress-circular>
                                                </v-row>
                                            </template>
                                            </v-img>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-textarea label="Comment or Description" v-model="item.Comment" hint="Brief description of the survey" persistent-hint rows="4" clearable counter></v-textarea>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-tab-item>
                            <!-- Questions -->
                            <v-tab-item class="mt-3 mb-3">
                                <v-row class="row-smaller mt-4 mb-0">
                                    <v-col sm="12">
                                        <v-slider
                                            v-model="indexOne"
                                            :thumb-size="24"
                                            thumb-label="always"
                                            min="1"
                                            :max="item.Questions.length"
                                            ticks="always"
                                            tick-size="4"
                                            color="accent"
                                            :prepend-icon="indexOne < 2 ? 'mdi-circle-medium' : 'mdi-chevron-left'"
                                            :append-icon="indexOne >= item.Questions.length ? 'mdi-circle-medium' : 'mdi-chevron-right'"
                                            @click:prepend="onPrevious"
                                            @click:append="onNext"
                                            dense
                                            hide-details></v-slider>
                                    </v-col>
                                </v-row>
                                <v-card class="mb-0 ml-1 mr-1">
                                    <v-card-text>
                                        <v-row class="row-smaller mt-0 mb-0">
                                            <v-col sm="4" align-self="center">
                                                <span class="subtitle-1">Question <span class="font-weight-black accent--text">{{ indexOne }}</span></span>
                                            </v-col>
                                            <v-col sm="4" align-self="center" class="text-center">
                                                <v-btn text @click="addQuestion"><v-icon>mdi-plus</v-icon>Add a Question</v-btn>
                                            </v-col>
                                            <v-col sm="4" align-self="end" class="text-end">
                                                <v-menu bottom right offset-y>
                                                    <template v-slot:activator="{ on }">
                                                        <!-- <v-icon v-on="on" class="error--text mr-2">mdi-delete-outline</v-icon> -->
                                                        <v-btn text v-on="on" class="error--text mr-2"><v-icon>mdi-delete-outline</v-icon>Remove Question</v-btn>
                                                    </template>
                                                    <v-btn color="error" @click="onRemoveQuestion()">
                                                        <v-icon class="mr-2">mdi-alert-decagram</v-icon>
                                                        Are you sure?
                                                    </v-btn>
                                                </v-menu>
                                            </v-col>
                                            <!-- <v-col sm="3" class="text-right">
                                                <span class="subtitle-2">Language</span>
                                                <v-chip class="ma-2" color="primary" label dark>
                                                    <v-icon left>mdi-translate</v-icon>
                                                    <span class="text-uppercase">{{ editLang }}</span>
                                                </v-chip>
                                            </v-col> -->
                                        </v-row>
                                        <v-row class="row-smaller mt-0 mb-0">
                                            <v-col sm="6">
                                                <span class="caption">Preview</span>
                                                <v-card flat color="#FAFAFA" class="preview-box">
                                                    <v-card-text>
                                                        <div class="question-label" v-html="question.Question[editLangIdx].Value || '<p>[Question]</p>'"></div>
                                                        <!-- <div class="question-label">{{ question.Question[editLangIdx].Value }}</div> -->
                                                        <div>
                                                            <!-- Text -->
                                                            <v-text-field
                                                                v-if="showInputType($CONST.INPUT_TYPE.Text) && (question.Lines || 1) < 2"
                                                                v-model="question.ValueStr"
                                                                :counter="question.Max || false"
                                                                :minlength="question.Min || false"
                                                                :maxlength="question.Max || false"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                @keyup="formatValidation()"
                                                                persistent-hint>
                                                            </v-text-field>
                                                            <v-textarea
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Text) && (question.Lines || 1) > 1"
                                                                v-model="question.ValueStr"
                                                                :rows="question.Lines || 2"
                                                                :counter="question.Max || false"
                                                                :minlength="question.Min || false"
                                                                :maxlength="question.Max || false"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                persistent-hint>
                                                            </v-textarea>
                                                            <!-- Number -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.Number)">
                                                                <v-numeric
                                                                    v-model="question.ValueNum"
                                                                    :maxlength="11"
                                                                    :prefix="question.Pre"
                                                                    :suffix="question.Post"
                                                                    :placeholder="question.InHint"
                                                                    :hint="question.OutHint"
                                                                    persistent-hint>
                                                                </v-numeric>
                                                                <span class="caption ml-2" v-if="!isBlank(question.Min) || !isBlank(question.Max)">{{ !isBlank(question.Min) && !isBlank(question.Max) ? `Must be between ${question.Min} and ${question.Max}` : (isBlank(question.Min) ? `Must not be greater than ${question.Max}` : `Must not be less than ${question.Min}`)}}</span>
                                                            </div>
                                                            <!-- Mobile -->
                                                            <v-text-field
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Mobile)"
                                                                v-model="question.ValueStr"
                                                                v-mask="'###-###-####'"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                :rules="[inputRules.mobile]"
                                                                prepend-icon="mdi-cellphone"
                                                                persistent-hint>
                                                            </v-text-field>
                                                            <!-- <v-text-field-simplemask
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Mobile)"
                                                                v-model="question.ValueStr"
                                                                v-bind:properties="{
                                                                    // prefix: 'question.Pre',
                                                                    // suffix: 'question.Post',
                                                                    readonly: false,
                                                                    disabled: false,
                                                                    outlined: false,
                                                                    // clearable: true,
                                                                    // placeholder: 'question.InHint',
                                                                }"
                                                                v-bind:options="{
                                                                    inputMask: '###-###-####',
                                                                    outputMask: '##########',
                                                                    empty: null,
                                                                    applyAfter: false,
                                                                    alphanumeric: false,
                                                                    lowerCase: false,
                                                                }"
                                                                /> -->
                                                            <!-- <v-mask
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Mobile)"
                                                                v-model="question.ValueStr"
                                                                v-mask="'###-###-####'"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                prepend-icon="mdi-cellphone"
                                                                persistent-hint>
                                                            </v-mask> -->
                                                            <!-- Email -->
                                                            <v-text-field
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Email)"
                                                                v-model="question.ValueStr"
                                                                :counter="question.Max || false"
                                                                :minlength="question.Min || false"
                                                                :maxlength="question.Max || false"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                :rules="[inputRules.email]"
                                                                prepend-icon="mdi-email-open-outline"
                                                                persistent-hint>
                                                            </v-text-field>
                                                            <!-- WebAddress -->
                                                            <v-text-field
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.WebAddress)"
                                                                v-model="question.ValueStr"
                                                                :counter="question.Max || false"
                                                                :minlength="question.Min || false"
                                                                :maxlength="question.Max || false"
                                                                :prefix="question.Pre"
                                                                :suffix="question.Post"
                                                                :placeholder="question.InHint"
                                                                :hint="question.OutHint"
                                                                :rules="[inputRules.web]"
                                                                prepend-icon="mdi-web"
                                                                persistent-hint>
                                                            </v-text-field>
                                                            <!-- YesNo -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.YesNo)">
                                                                <v-btn-toggle
                                                                    v-model="question.ValueBool"
                                                                    color="accent"
                                                                    group
                                                                    tile>
                                                                    <v-btn :value="true" class="pl-11 pr-11">
                                                                        Yes
                                                                    </v-btn>
                                                                    <v-btn :value="false" class="pl-12 pr-12">
                                                                        No
                                                                    </v-btn>
                                                                </v-btn-toggle>
                                                                <div v-if="question.OutHint !== ''">
                                                                    <v-divider class="ml-8"></v-divider>
                                                                    <div class="v-text-field__details ml-8 mt-2" >
                                                                        <div class="v-messages theme--light">
                                                                            <div class="v-messages__wrapper">
                                                                                <div class="v-messages__message" >{{question.OutHint}}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <!-- Select One -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.SelectOne)">
                                                                <!-- Filter -->
                                                                <v-text-field v-show="question.Filter" v-model="filterOne" class="w-512-max" dense single-line hint="Type to search and filter the available options" prepend-icon="mdi-magnify" persistent-hint></v-text-field>
                                                                <span v-show="question.Filter" class="caption opa-6 ml-8">A maximum result of 20 options will be shown.</span>
                                                                <!-- Options -->
                                                                <v-radio-group v-model="question.ValueStr">
                                                                    <v-radio
                                                                        v-for="item in optionsOne"
                                                                        :key="item._id"
                                                                        :label="item.Value"
                                                                        :value="item.Value">
                                                                    </v-radio>
                                                                </v-radio-group>
                                                                <span class="caption">{{ question.OutHint }}</span>
                                                            </div>
                                                            <!-- Select Many -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.SelectMany)">
                                                                <!-- Filter -->
                                                                <v-text-field v-show="question.Filter" v-model="filterMany" class="w-512-max" dense single-line hint="Type to search and filter the available options" prepend-icon="mdi-magnify" persistent-hint @keyup.native="filterManyChange"></v-text-field>
                                                                <span v-show="question.Filter" class="caption opa-6 ml-8">A maximum result of 20 options will be shown.</span>
                                                                <!-- Options -->
                                                                <v-checkbox
                                                                    v-model="question.ValueArr"
                                                                    v-for="item in optionsMany"
                                                                    :key="item._id"
                                                                    :label="item.Value"
                                                                    :value="item.Value"
                                                                    class="mt-1"
                                                                    multiple
                                                                    hide-details>
                                                                </v-checkbox>
                                                                <span class="caption mt-6 d-block">{{ question.OutHint }}</span>
                                                            </div>
                                                            <!-- Date -->
                                                            <v-menu
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Date)"
                                                                v-model="modalDate"
                                                                :close-on-content-click="false"
                                                                :nudge-right="32"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="290px">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="question.ValueDate"
                                                                        :placeholder="question.InHint"
                                                                        :hint="question.OutHint"
                                                                        prepend-icon="mdi-calendar"
                                                                        persistent-hint
                                                                        readonly
                                                                        v-on="on">
                                                                    </v-text-field>
                                                                </template>
                                                                <v-date-picker v-model="question.ValueStr" @input="modalDate = false"></v-date-picker>
                                                            </v-menu>
                                                            <!-- Time -->
                                                            <v-menu
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.Time)"
                                                                ref="menu"
                                                                v-model="modalTime"
                                                                :close-on-content-click="false"
                                                                :nudge-right="32"
                                                                transition="scale-transition"
                                                                offset-y
                                                                max-width="290px"
                                                                min-width="290px">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="question.ValueTime"
                                                                        :placeholder="question.InHint"
                                                                        :hint="question.OutHint"
                                                                        prepend-icon="mdi-clock-outline"
                                                                        format="24hr"
                                                                        scrollable
                                                                        persistent-hint
                                                                        readonly
                                                                        v-on="on">
                                                                    </v-text-field>
                                                                </template>
                                                                <v-time-picker v-model="question.ValueStr" @click:minute="modalTime = false"></v-time-picker>
                                                            </v-menu>
                                                            <!-- DOB -->
                                                            <v-menu
                                                                v-else-if="showInputType($CONST.INPUT_TYPE.DateOfBirth)"
                                                                v-model="modalDOB"
                                                                :close-on-content-click="false"
                                                                :nudge-right="32"
                                                                transition="scale-transition"
                                                                offset-y
                                                                min-width="290px">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field
                                                                        v-model="question.ValueDate"
                                                                        :placeholder="question.InHint"
                                                                        :hint="question.OutHint"
                                                                        prepend-icon="mdi-gift-outline"
                                                                        persistent-hint
                                                                        readonly
                                                                        v-on="on">
                                                                    </v-text-field>
                                                                </template>
                                                                <v-date-picker ref="previewDOB" v-model="question.ValueStr" @input="modalDOB = false" :max="new Date().toISOString().substr(0, 10)"></v-date-picker>
                                                            </v-menu>
                                                            <!-- Rating -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.Rating)">
                                                                <v-rating
                                                                    v-model="question.ValueNum"
                                                                    :length="question.Max || 5"
                                                                    color="accent"
                                                                    background-color="grey lighten-1"></v-rating>
                                                                <span class="caption">{{ question.OutHint }}</span>
                                                            </div>
                                                            <!-- Slider -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.RangeSlider)">
                                                                <v-row class="row-smaller mt-7">
                                                                    <v-col sm="12" class="d-flex">
                                                                        <span class="body-1 mr-2" v-show="question.Pre">{{ question.Pre }}</span>
                                                                        <v-slider
                                                                            v-model="question.ValueNum"
                                                                            :thumb-size="24"
                                                                            :min="question.Min || 0"
                                                                            :max="question.Max || 10"
                                                                            :step="question.Step || 1"
                                                                            :hint="question.OutHint"
                                                                            thumb-label="always"
                                                                            ticks="always"
                                                                            tick-size="4"
                                                                            color="accent"
                                                                            persistent-hint>
                                                                        </v-slider>
                                                                        <span class="body-1 ml-2" v-show="question.Post">{{ question.Post }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row class="row-smaller">
                                                                    <v-col sm="12" class="text-center display-1 accent--text" align-self="center">
                                                                        <span>{{ question.ValueStr }}</span>
                                                                    </v-col>
                                                                </v-row>
                                                            </div>
                                                            <!-- Image -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.Image)">
                                                                <v-btn color="primary" class="mr-2" @click="onTakePicture">
                                                                    <v-icon left>mdi-camera</v-icon>
                                                                    Take Picture
                                                                </v-btn>
                                                                <v-btn color="primary" v-if="question.Local" @click="onFileLoadPhotoClick">
                                                                    <v-icon left>mdi-folder-image</v-icon>
                                                                    Load Image
                                                                </v-btn>
                                                                <v-file-input ref="fileLoadPhoto" v-model="question.ValueFile" accept="image/*" label="Load Image" class="d-none" @change="onFileLoadChange"></v-file-input>
                                                                <br/>
                                                                <v-img :src="question.ValueStr" class="mt-2"></v-img><!-- https://picsum.photos/510/300?random -->
                                                                <span class="caption">{{ question.OutHint }}</span>
                                                            </div>
                                                            <!-- Signature -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.Signature)">
                                                                <v-icon>mdi-fingerprint</v-icon>
                                                                <v-btn color="primary" class="mr-2" @click="onSign">
                                                                    <v-icon left>mdi-fingerprint</v-icon>
                                                                    Sign
                                                                </v-btn>
                                                                <v-btn color="primary" v-if="question.Local" @click="onFileLoadSignClick">
                                                                    <v-icon left>mdi-folder-image</v-icon>
                                                                    Load
                                                                </v-btn>
                                                                <v-btn color="primary" class="error ml-2 float-right" @click="onSignClear">
                                                                    <v-icon text>mdi-delete-forever-outline</v-icon>
                                                                </v-btn>
                                                                <v-file-input ref="fileLoadSign" v-model="question.ValueFile" accept="image/*" label="Load Image" class="d-none" @change="onFileLoadChange"></v-file-input>
                                                                <br/>
                                                                <canvas id="user-sign" style="width: 100%; height: 300px; border: 10px solid #EEEEEE;"></canvas>
                                                                <v-img :src="question.ValueStr" class="mt-2"></v-img><!-- https://picsum.photos/510/300?random -->
                                                                <span class="caption">{{ question.OutHint }}</span>
                                                            </div>
                                                            <!-- GPS Location -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.GPSLocation)">
                                                                <v-btn color="primary" @click="getLocation">
                                                                    <v-icon left>mdi-map-marker-radius</v-icon>
                                                                    Get Location
                                                                </v-btn>
                                                                <br/>
                                                                <span class="caption">{{ question.OutHint }}</span>
                                                                <v-row class="w-512-max mt-2">
                                                                    <v-col sm="4">Coordinates</v-col>
                                                                    <v-col sm="8" class="font-weight-bold subtitle-1">{{ question.ValueStr || '-' }}</v-col>
                                                                </v-row>
                                                                <v-row class="w-512-max">
                                                                    <v-col sm="4">Latitude</v-col>
                                                                    <v-col sm="8">{{ question.ValueLat || '-' }}</v-col>
                                                                </v-row>
                                                                <v-row class="w-512-max">
                                                                    <v-col sm="4">Longitude</v-col>
                                                                    <v-col sm="8">{{ question.ValueLon || '-' }}</v-col>
                                                                </v-row>
                                                                <v-row class="w-512-max">
                                                                    <v-col sm="4">Accuracy</v-col>
                                                                    <v-col sm="8" :class="question.ValueAccFail ? 'error--text' : ''">{{ question.ValueAcc || '-' }}</v-col>
                                                                </v-row>
                                                                <v-row class="w-512-max">
                                                                    <v-col sm="4">Altitude</v-col>
                                                                    <v-col sm="8">{{ question.ValueAlt || '-' }}</v-col>
                                                                </v-row>
                                                                <!-- <v-row class="w-512-max">
                                                                    <v-col sm="4">Speed</v-col>
                                                                    <v-col sm="8">{{ question.ValueSpd || '-' }}</v-col>
                                                                </v-row> -->
                                                            </div>
                                                            <!-- Barcode -->
                                                            <div v-else-if="showInputType($CONST.INPUT_TYPE.Barcode)">
                                                                <div class="d-flex">
                                                                    <div class="flex-grow-1">
                                                                        <v-text-field
                                                                            v-model="question.ValueStr"
                                                                            prepend-icon="mdi-qrcode-scan"
                                                                            :readonly="!question.Manual"
                                                                            :prefix="question.Pre"
                                                                            :suffix="question.Post"
                                                                            :placeholder="question.InHint"
                                                                            :hint="question.OutHint"
                                                                            persistent-hint>
                                                                            <!-- <template v-slot:append-outer>
                                                                                <v-btn color="primary" @click="onScanBarcode">Scan</v-btn>
                                                                            </template> -->
                                                                        </v-text-field>
                                                                    </div>
                                                                    <div class="flex-shrink-1 pt-3 pl-2">
                                                                        <v-btn color="primary" @click="onScanBarcode">Scan</v-btn>
                                                                    </div>
                                                                </div>
                                                                <div id="qr-reader" style="height: 100%"></div>
                                                                <!-- <v-row class="w-512-max mt-2">
                                                                    <v-col sm="12" class="font-weight-bold">{{ question.ValueStr || '-' }}"</v-col>
                                                                </v-row> -->
                                                            </div>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                            <v-col sm="6">
                                                <v-row class="row-smaller mt-0 mb-0">
                                                    <v-col sm="12">
                                                        <span class="caption">Question text in English</span>
                                                        <quill-editor v-model="question.Question[editLangIdx].Value" ref="questionText" :options="editorOption"></quill-editor>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="row-smaller mt-0 mb-0" v-if="question.InputType === 8 || question.InputType === 9 || question.InputType === 19" >
                                                    <v-col sm="8">
                                                        <v-select label="Input Type" v-model="question.InputType" :items="inputTypes" item-text="Name" item-value="_id" hint="Control type for user to supply the answer" persistent-hint @change="onInputTypeChange"></v-select>
                                                    </v-col>
                                                    <v-col sm="4">
                                                        <v-btn color="primary" class="w-100p mt-3" @click.stop="optionListPop = true">List</v-btn>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="row-smaller mt-0 mb-0" v-else>
                                                    <v-col sm="12">
                                                        <v-select label="Input Type" v-model="question.InputType" :items="inputTypes" item-text="Name" item-value="_id" hint="Control type for user to supply the answer" persistent-hint @change="onInputTypeChange"></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="row-smaller mt-0 mb-0">
                                                    <v-tabs grow>
                                                        <v-tab>Visual</v-tab>
                                                        <v-tab>Settings</v-tab>
                                                        <v-tab>Rules</v-tab>
                                                        <!-- Visual -->
                                                        <v-tab-item class="mt-3 mb-3">
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.InHint)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.InHint" label="Inside hint" hint="Helper text inside of the text input area" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.OutHint)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.OutHint" label="Outside hint" hint="Helper text underneath the text input area" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Pre)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Pre" label="Prefix" hint="Text to display at the start of the input area" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Post)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Post" label="Suffix" hint="Text to display at the end of the input area" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Lines)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Lines" label="Lines/Size" hint="Input area lines." persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.NumType)">
                                                                <v-col sm="12">
                                                                    <v-select label="Number Type" v-model="question.NumType" :items="numberTypeOptions" item-text="text" item-value="id" hint="The type of number" persistent-hint></v-select>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption(-1)">
                                                                <v-col sm="12">
                                                                    <v-alert dense text border="left" class="mt-3 opa-5" icon="mdi-information-outline">
                                                                        No visual options for this input type.
                                                                    </v-alert>
                                                                </v-col>
                                                            </v-row>
                                                        </v-tab-item>
                                                        <!-- Settings -->
                                                        <v-tab-item class="mt-3 mb-3">
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Default)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Default" label="Default value" hint="Initial value e.g. REG- or 0 or {today}" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Min)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Min" :label="question.InputType === $CONST.INPUT_TYPE.Text ? 'Minimum text length' : 'Minimum'" :hint="question.InputType === $CONST.INPUT_TYPE.Text ? 'Restrict the minimum number of characters' : 'Lowest'" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Max)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Max" :label="question.InputType === $CONST.INPUT_TYPE.Text ? 'Maximum text length' : 'Maximum'" :hint="question.InputType === $CONST.INPUT_TYPE.Text ? 'Restrict the maximum number of characters' : 'Highest'" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <!--
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Format)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Format" label="Format" hint="Input format e.g. yyyy/mm/dd" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            -->
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.LoopParent)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.LoopParent" label="Loop next questions" hint="Following question range to loop" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Quality)">
                                                                <v-col sm="12">
                                                                    <span class="caption">Adjust image quality</span>
                                                                    <v-slider v-model="question.Quality" hint="Adjust the image quality to reduce file size" persistent-hint dense inverse-label :label="`${question.Quality}%`" min="60" max="100" append-icon="mdi-magnify-plus" prepend-icon="mdi-magnify-minus" @click:append="onQualityUp" @click:prepend="onQualityDown"></v-slider>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Width)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Width" label="Adjust to width" hint="Resize the image to this width" suffix="pixels" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Height)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Height" label="Adjust to height" hint="Resize the image to this height" suffix="pixels" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Local)">
                                                                <v-col sm="12">
                                                                    <v-switch v-model="question.Local" label="Allow local file" hint="Allow loading of a local file" persistent-hint></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showInputType($CONST.INPUT_TYPE.Text) && (question.Lines || 1) < 2">
                                                                <v-col sm="12">
                                                                    <v-select
                                                                        v-model="question.Format"
                                                                        :items="[{key:'Mixed', value:''},{key:'CAPS',value:'CAPS'},{key:'Lower',value:'LOWER'}]"
                                                                        item-text="key"
                                                                        item-value="value"
                                                                        label="Select text format"
                                                                        @change="formatValidation()"></v-select>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Manual)">
                                                                <v-col sm="12">
                                                                    <v-switch v-model="question.Manual" label="Manual entry" hint="Allow manual entry" persistent-hint></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Timeout)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Timeout" label="Timeout" hint="Time to wait for an accurate measurement" suffix="seconds" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Accuracy)">
                                                                <v-col sm="12">
                                                                    <v-text-field v-model="question.Accuracy" label="Accuracy" hint="The measurement may be out with minimum this amount" suffix="meters" persistent-hint></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.GPSSkip)">
                                                                <v-col sm="12">
                                                                    <v-switch v-model="question.GPSSkip" label="Skip on accuracy fail" hint="Allow to skip the question if the measurement cannot achieve minimum accuracy" persistent-hint></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption($CONST.INPUT.Filter)">
                                                                <v-col sm="12">
                                                                    <v-switch v-model="question.Filter" label="Filter" hint="Flag to show search input to allow user to filter the options list" persistent-hint></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-show="showOption(-1)">
                                                                <v-col sm="12">
                                                                    <v-alert dense text border="left" class="mt-3 opa-5" icon="mdi-information-outline">
                                                                        No settings options for this input type.
                                                                    </v-alert>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller">
                                                                <v-col sm="12">
                                                                    <v-switch v-model="question.Optional" label="Optional" hint="Flag if this question may be skipped" persistent-hint></v-switch>
                                                                </v-col>
                                                            </v-row>
                                                        </v-tab-item>
                                                        <!-- Rules -->
                                                        <v-tab-item class="mt-3 mb-3">
                                                            <v-row class="row-smaller">
                                                                <v-col sm="6" align-self="center">
                                                                    Show Rules <b>{{ question.ShowRules.length }}</b>
                                                                </v-col>
                                                                <v-col sm="6" class="text-right">
                                                                    <v-btn color="primary" class="mt-2" @click="showRulesPop = true"><v-icon class="mr-2">mdi-keyboard-settings-outline</v-icon>Manage</v-btn>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller">
                                                                <v-col sm="6" align-self="center" >
                                                                    Pass Rules <b>{{ question.PassRules.length }}</b>
                                                                    <v-tooltip top>
                                                                        <template v-slot:activator="{ on }">
                                                                            <v-icon v-on="on" color="info" class="ml-2" v-if="question.Optional">mdi-information-outline</v-icon>
                                                                        </template>
                                                                        <div>Note that this question is Optional.</div>
                                                                        <div>Only "Jump" rules will be actioned.</div>
                                                                    </v-tooltip>
                                                                </v-col>
                                                                <v-col sm="6" class="text-right">
                                                                    <v-btn color="primary" class="mt-2" @click="passRulesPop = true"><v-icon class="mr-2">mdi-keyboard-settings-outline</v-icon>Manage</v-btn>
                                                                </v-col>
                                                            </v-row>
                                                            <v-row class="row-smaller" v-if="item.Rating">
                                                                <v-col sm="6" align-self="center">
                                                                    Rating Rules <b>{{ question.RatingRules.length }}</b>
                                                                </v-col>
                                                                <v-col sm="6" class="text-right">
                                                                    <v-btn color="primary" class="mt-2" @click="ratingRulesPop = true"><v-icon class="mr-2">mdi-keyboard-settings-outline</v-icon>Manage</v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-tab-item>
                                                    </v-tabs>
                                                </v-row>
                                                <!-- <v-row class="row-smaller">
                                                    <v-col sm="12">
                                                        <v-select label="Options" v-model="question" :items="item.Questions" item-text="item.Question" item-value="_id" hint="Control type for user to supply the answer" persistent-hint></v-select>
                                                    </v-col>
                                                </v-row> -->
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-btn text :disabled="indexOne < 2" @click="onPrevious"><v-icon>mdi-chevron-left</v-icon>Previous</v-btn>
                                        <v-spacer></v-spacer>
                                        <v-btn text @click="onPreview">Preview</v-btn>
                                        <v-btn text @click.stop="reorderPop = true">Re-order</v-btn>
                                        <v-menu top offset-y absolute v-model="jumpPop">
                                            <template v-slot:activator="{ on }">
                                                <v-btn text v-on="on">Jump To</v-btn>
                                            </template>
                                            <div>
                                                <v-text-field v-model="jumpText" class="ml-3 mr-3 mt-3" autofocus dense single-line hint="Question index to jump to" prepend-icon="mdi-magnify" persistent-hint @keyup.native="jumpChange"></v-text-field>
                                                <v-list class="pop-scroll-box">
                                                    <v-list-item v-for="q in this.item.Questions" :key="q._id" @click="onJump(q.Index)">
                                                        <v-list-item-title>{{ q.Index }}.<span class="ml-2">{{ q.Question[editLangIdx].Value.replace(tagReg, '').substr(0, 50) }}</span></v-list-item-title>
                                                    </v-list-item>
                                                </v-list>
                                            </div>
                                        </v-menu>
                                        <v-spacer></v-spacer>
                                        <v-btn text :disabled="indexOne >= item.Questions.length" @click="onNext">Next<v-icon>mdi-chevron-right</v-icon></v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-tab-item>
                            <!-- Style -->
                            <!-- <v-tab-item class="mt-3 mb-3">
                                <v-form ref="formStyle" v-model="isValidStyle">
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.OnDash" label="Continuous or Paged" hint="???" persistent-hint></v-switch>
                                        </v-col>
                                    </v-row>
                                    Layout
                                    Image
                                    Colour
                                    Font
                                </v-form>
                            </v-tab-item> -->
                            <!-- Messages -->
                            <v-tab-item class="mt-3 mb-3">
                                <v-form ref="formMessages" v-model="isValidMessages">
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-switch v-model="item.ShowStart" label="Start/Cover message" hide-details></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <!-- <v-textarea label="Start Message" v-model="item.StartMessage" hint="This message will be shown to the capturer when the form is started" rows="4" :disabled="!item.ShowStart" persistent-hint clearable counter></v-textarea> -->
                                            <quill-editor v-model="item.StartMessage" ref="startText" :options="editorOptionMore" v-show="item.ShowStart" class="mt-2 editor-larger"></quill-editor>
                                            <span class="caption">This message will be shown to the capturer when the form is started</span>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-switch v-model="item.ShowEnd" label="End message" hide-details></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <!-- <v-textarea label="Start Message" v-model="item.EndMessage" hint="This message will be shown to the capturer when the form has ended" rows="4" :disabled="!item.ShowEnd" persistent-hint clearable counter></v-textarea> -->
                                            <quill-editor v-model="item.EndMessage" ref="endText" :options="editorOptionMore" v-show="item.ShowEnd" class="mt-2 editor-larger"></quill-editor>
                                            <span class="caption">This message will be shown to the capturer when the form has ended</span>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-tab-item>
                            <!-- Properties -->
                            <v-tab-item class="mt-3 mb-3">
                                <v-form ref="formProperties" v-model="isValidProperties">
                                    <v-subheader class="text-uppercase mt-1 mb-3" style="height: 20px;">Dashboard</v-subheader>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.OnDash" label="Show on Dashboard" hint="Displays a counter block on the dashboard" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-text-field label="Dashboard Name" v-model="item.DashName" hint="Name to display on the Dashboard" persistent-hint :disabled="!item.OnDash"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.ColorOn" label="Custom Colour" hint="Assign a specific colour to the survey" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6" align-self="center">
                                            <v-menu v-model="colourPop" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field
                                                        :value="item.Color"
                                                        :disabled="!item.ColorOn"
                                                        placeholder="Colour"
                                                        hint="Set a custom colour"
                                                        append-icon="mdi-format-color-fill"
                                                        persistent-hint
                                                        v-on="on">
                                                        <template v-slot:append-outer>
                                                            <v-chip v-on="on" class="elevation-1" :color="item.ColorOn ? (item.Color || 'white') : 'white'" label :disabled="!item.ColorOn">
                                                                <v-icon :color="colorText">mdi-format-color-text</v-icon>
                                                            </v-chip>
                                                        </template>
                                                    </v-text-field>
                                                </template>
                                                <v-color-picker v-model="item.Color" swatches-max-height="100" canvas-height="200" dot-size="30" show-swatches flat></v-color-picker>
                                                <v-divider></v-divider>
                                                <div class="d-flex">
                                                    <v-spacer></v-spacer>
                                                    <v-btn text @click="colourPop = false">Close</v-btn>
                                                </div>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-chip-group v-model="iconIndex" column active-class="accent--text" @change="onIconChange">
                                                <v-chip v-for="icon in iconPaged" :key="icon">
                                                    <v-icon medium>{{ icon }}</v-icon>
                                                </v-chip>
                                            </v-chip-group>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="12">
                                            <v-pagination v-model="iconPage" :length="iconPages" @next="setIconsPage" @previous="setIconsPage" @input="setIconsPage"></v-pagination>
                                        </v-col>
                                    </v-row>
                                    <v-subheader class="text-uppercase mt-8 mb-3" style="height: 20px;">General</v-subheader>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.Form" label="Display as a single form" hint="All questions will be visible" persistent-hint></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.Rating" label="Rating engine" hint="Activate rating engine and controls" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-switch v-model="item.RatingTotal" label="Display the rating total" hint="The total will be displayed alongside of the NEXT button" persistent-hint></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.Once" label="Once-off survery" hint="Only one answer per person" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-select label="Unique Field" v-model="item.OnceField" :items="item.Questions" item-text="Index" item-value="_id" :disabled="!item.Once" hint="Identifier field to check for unique value to limit input" persistent-hint></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.PopLast" label="Populate with last entry" hint="The last recorded entry will be loaded" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-switch v-model="item.PopRestrict" label="Restrict to capturer" hint="If using authentication, load last by user" :disabled="!item.PopLast" persistent-hint></v-switch>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.Approval" label="Requires Approval" hint="Submissions must be reviewed and approved" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6" class="align-self-center">
                                            <v-btn color="primary" :disabled="!item.Approval" @click.stop="reasonsPop = true">Rejection Reasons</v-btn>
                                            <!-- <v-select label="Rejection Reasons" v-model="item.Reasons" :items="approverOptions" item-text="Name" item-value="_id" :disabled="!item.Approval" hint="Approver that is a registered system user" persistent-hint></v-select> -->
                                            <!-- <span class="caption">This message will be shown to the capturer when the form has ended</span> -->
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.Notify" label="Notifications" hint="Enable notification on submission" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="6">
                                            <v-text-field label="Email to" v-model="item.NotifyEmail" hint="Recipient email address" persistent-hint :disabled="!item.Notify"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-switch v-model="item.NotifyDetail" label="Detailed" hint="Basic notification or full form answer" persistent-hint :disabled="!item.Notify"></v-switch>
                                        </v-col>
                                        <!-- <v-col sm="6">
                                            <v-text-field label="Email to" v-model="item.DashName" hint="Recipient email address" persistent-hint :disabled="!item.OnDash"></v-text-field>
                                        </v-col> -->
                                    </v-row>
                                    <v-subheader class="text-uppercase mt-10 mb-3" style="height: 20px;">
                                        Generated Fields &amp; Values
                                        <v-btn icon color="info" class="ml-2" @click.stop="autoInfoPop = true">
                                            <v-icon>mdi-information-outline</v-icon>
                                        </v-btn>
                                    </v-subheader>
                                    <v-row class="row-smaller">
                                        <v-col sm="4">
                                            <v-switch v-model="item.Auto1" label="Enable field 1" hint="Enable 1st auto-generated field" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Field name 1" v-model="item.Auto1Field" hint="Specify a unique field name" persistent-hint :disabled="!item.Auto1"></v-text-field>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Value format 1" v-model="item.Auto1Field" hint="Format the number must be generated in" persistent-hint :disabled="!item.Auto1"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="4">
                                            <v-switch v-model="item.Auto2" label="Enable field 2" hint="Enable 2nd auto-generated field" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Field name 2" v-model="item.Auto2Field" hint="Specify a unique field name" persistent-hint :disabled="!item.Auto2"></v-text-field>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Value format 2" v-model="item.Auto2Field" hint="Format the number must be generated in" persistent-hint :disabled="!item.Auto2"></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller">
                                        <v-col sm="4">
                                            <v-switch v-model="item.Auto3" label="Enable field 3" hint="Enable 3rd auto-generated field" persistent-hint></v-switch>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Field name 3" v-model="item.Auto3Field" hint="Specify a unique field name" persistent-hint :disabled="!item.Auto3"></v-text-field>
                                        </v-col>
                                        <v-col sm="4">
                                            <v-text-field label="Value format 3" v-model="item.Auto3Field" hint="Format the number must be generated in" persistent-hint :disabled="!item.Auto3"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-tab-item>
                            <!-- Relationship -->
                             <v-tab-item class="mt-3 mb-3">
                                <v-form ref="formRelationship" v-model="isValidRelationship">
                                    <v-row class="row-smaller">
                                        <v-col sm="6">
                                            <v-select label="Relationship Type" v-model="item.RelationshipType" :items="relationshipOptions" item-text="text" item-value="id" hint="Provides a mandatory selection list when the form is started, if not None" persistent-hint></v-select>
                                        </v-col>
                                        <v-col sm="5">
                                            <v-switch v-model="item.ParentRestrict" label="Restrict to capturer" hint="Restrict parent records by user (User Id)" persistent-hint v-show="item.RelationshipType !== 'N'"></v-switch>
                                        </v-col>
                                        <v-col sm="1" class="text-right">
                                            <v-btn icon color="info" class="mt-3" @click.stop="restrictInfoPop = true" v-show="item.RelationshipType !== 'N'">
                                                <v-icon>mdi-information-outline</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller" v-show="item.RelationshipType === 'M'">
                                        <v-col sm="12">
                                            <v-select label="Primary List to link to" v-model="item.ParentId" :items="primaryLists" item-text="Name" item-value="_id" hint="Link a primary record to a form submission" persistent-hint @change="onPrimaryChange"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-simple-table fixed-header height="400" v-if="selectedPrimary && item.RelationshipType === 'M'">
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-center w-50">#</th>
                                                <th class="text-left">Field Label</th>
                                            </tr>
                                            </thead>
                                            <tr v-for="(label, i) in selectedPrimary.Labels" :key="i">
                                                <td class="text-center">{{ label.Index }}</td>
                                                <td>
                                                    <v-text-field v-model="label.Value" placeholder="Capture label text" hide-details single-line solo flat></v-text-field>
                                                </td>
                                            </tr>
                                            <tfoot v-if="!selectedPrimary.Labels.length"><tr><td colspan="3" class="text-center">No data.</td></tr></tfoot>
                                        </template>
                                    </v-simple-table>
                                    <!-- <v-row class="row-smaller" v-show="item.RelationshipType !== 'N'">
                                        <v-col sm="12">
                                            <v-select :label="`${item.RelationshipType === 'S' ? 'Survey' : 'Primary List'} to link to`" v-model="item.ParentId" :items="surveyListOptions" item-text="Name" item-value="_id" hint="Link a form as the mandatory parent" persistent-hint @change="onSurveyChange"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller" v-show="item.RelationshipType !== 'N'">
                                        <v-col sm="9">
                                            <v-select label="Fields to display" v-model="relationshipSurveyFields" :items="surveyFieldsOptions" item-text="QuestionTxt" item-value="Field" hint="Select all fields that must be displayed" multiple persistent-hint @change="onFieldDisplayChange"></v-select>
                                        </v-col>
                                        <v-col sm="3" class="text-right" style="padding-top:10px !important;">
                                            <span class="subtitle-2">Language</span>
                                            <v-chip class="ma-2" color="primary" label dark>
                                                <v-icon left>mdi-translate</v-icon>
                                                <span class="text-uppercase">{{ editLang }}</span>
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller" v-show="item.RelationshipType !== 'N'">
                                        <v-col sm="12" style="position: relative">
                                            <draggable v-model="item.RelationSurveyFields" tag="tr" @start="drag = true" @end="drag = false" class="d-block">
                                                <v-data-table :headers="relationSurveyHeaders" :items="item.RelationSurveyFields" hide-default-footer no-data-text="No data.">
                                                </v-data-table>
                                            </draggable>
                                        </v-col>
                                    </v-row>
                                    <v-row class="row-smaller" v-show="item.RelationshipType !== 'N'">
                                        <v-col sm="12">
                                            <v-select label="Fields to filter on" v-model="relationshipSurveyFields" :items="item.RelationSurveyFields" item-text="LabelTxt" item-value="Field" hint="Select the fields allowed to filter on" multiple persistent-hint></v-select>
                                        </v-col>
                                    </v-row> -->
                                </v-form>
                            </v-tab-item>
                        </v-tabs>
                        <v-row class="row-smaller mt-4 mb-2">
                            <v-col sm="12" class="d-flex">
                                <v-btn color="primary" :disabled="!isValidDetail" :loading="isSaving" @click="onSave">Save</v-btn>
                                <v-btn class="ml-3" @click="onDuplicate" v-show="item._id">Duplicate</v-btn>
                                <v-btn class="ml-3" @click="onCancel">Cancel</v-btn>
                                <v-spacer></v-spacer>
                                <v-btn v-if="item._id && item.Version !== item.PublishedVer" :loading="isPublishing" color="warning" @click="onPublish">Publish v.{{item.Version}}</v-btn>
                                <v-spacer></v-spacer>
                                <v-menu bottom left offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" color="error" v-show="item._id" :loading="isDeleting">Delete Form</v-btn>
                                    </template>
                                    <v-btn color="error" @click="onDelete">
                                        <v-icon class="mr-2">mdi-alert-decagram</v-icon>
                                        Are you sure?
                                    </v-btn>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <v-dialog v-model="restrictInfoPop" max-width="400">
            <v-card dark color="info">
                <v-card-title class="headline">Restrict to capturer</v-card-title>
                <v-card-text class="body-1 white--text">
                    Instead of loading the entire list, only records that are linked to the logged-in user will be loaded.
                    Please note that only valid system users can be used, otherwise no records will be displayed, preventing the form from being completed.
                    The primary list must have a field named User ID and the id must either be a valid username or record id.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="restrictInfoPop = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="ruleInfoPop" max-width="1000">
            <v-card dark color="info">
                <v-card-title class="headline">Rule Information</v-card-title>
                <v-card-text class="body-1 white--text">
                    <pre>{{ $CONST.RULE_INFO_TEXT }}</pre>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="ruleInfoPop = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="reorderPop" max-width="800">
            <v-card>
                <v-card-title class="headline pb-0">Question Order</v-card-title>
                <v-card-text>
                    <v-row class="row-list mt-2 mb-0">
                        <v-col sm="12">
                            <span class="caption ml-2 mb-4">Question numbers are adjusted on move end.</span>
                        </v-col>
                    </v-row>
                    <v-row class="row-list mt-0 mb-0">
                        <v-col sm="1" align-self="center" class="text-center">
                            <v-icon class="optionHandle">mdi-drag</v-icon>
                        </v-col>
                        <v-col sm="2" align-self="center">
                            <span class="subtitle-1 text-uppercase">#</span>
                        </v-col>
                        <v-col sm="8" align-self="center">
                            <span class="subtitle-1 text-uppercase">Question</span>
                        </v-col>
                        <v-col sm="1" align-self="center">
                            <span class="subtitle-1 text-uppercase">&nbsp;</span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <div style="max-height:500px; overflow-y:auto; overflow-x:hidden;">
                        <draggable v-model="item.Questions" tag="div" handle=".optionHandle" @start="drag = true" @end="onOrderEnd" class="d-block custom-list">
                            <v-row class="row-list v-list-item v-list-item--link theme--light mt-0 mb-0" v-for="q in item.Questions" :key="q._id">
                                <v-col sm="1" align-self="center" class="text-center">
                                    <v-icon class="optionHandle">mdi-drag</v-icon>
                                </v-col>
                                <v-col sm="2">
                                    <span class="body-1">{{ q.Index }}</span>
                                </v-col>
                                <v-col sm="8">
                                    <span class="body-1">{{ q.Question[editLangIdx].Value.substr(0, 50).replace(tagReg, "") }}</span>
                                </v-col>
                                <v-col sm="1" align-self="center" class="text-right">
                                    <v-icon class="error--text mr-2" @click="onRemoveQuestion(q._id)">mdi-delete-outline</v-icon>
                                </v-col>
                            </v-row>
                        </draggable>
                    </div>
                    <v-divider></v-divider>
                    <v-row class="row-list mt-0 mb-0">
                        <v-col cols="12" class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn text class="mt-2" @click="removeOptionsAll">Remove All<v-icon>mdi-delete-outline</v-icon></v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="reorderPop = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="optionListPop" scrollable max-width="800">
            <v-card>
                <v-card-title class="headline pb-0">Manage Option List</v-card-title>
                <v-card-subtitle class="pb-0 pt-3 mt-0 mb-0">
                    <v-row class="row-list mt-0 mb-0">
                        <v-col sm="1" align-self="center" class="text-center">
                            <v-icon class="optionHandle">mdi-drag</v-icon>
                        </v-col>
                        <v-col sm="2" align-self="center">
                            <span class="subtitle-1 text-uppercase">ID</span>
                        </v-col>
                        <v-col sm="8" align-self="center">
                            <span class="subtitle-1 text-uppercase">Option Value/Text</span>
                        </v-col>
                        <v-col sm="1" align-self="center">
                            <span class="subtitle-1 text-uppercase">&nbsp;</span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                </v-card-subtitle>
                <v-card-text style="min-height: 300px; max-height: 500px;">
                    <draggable v-model="question.Options" tag="div" handle=".optionHandle" @start="drag = true" @end="drag = false" class="d-block custom-list">
                        <v-row class="row-list v-list-item v-list-item--link theme--light mt-0 mb-0" v-for="opt in question.Options" :key="opt._id">
                            <v-col sm="1" align-self="center" class="text-center">
                                <v-icon class="optionHandle">mdi-drag</v-icon>
                            </v-col>
                            <v-col sm="2">
                                <v-text-field v-model="opt._id" placeholder="Capture" hide-details single-line solo flat></v-text-field>
                            </v-col>
                            <v-col sm="8">
                                <v-text-field v-model="opt.Value" placeholder="Capture" hide-details single-line solo flat></v-text-field>
                            </v-col>
                            <v-col sm="1" align-self="center" class="text-right">
                                <v-icon class="error--text" @click="removeOptionItem(opt)">mdi-delete-outline</v-icon>
                            </v-col>
                        </v-row>
                    </draggable>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-container class="pt-0">
                        <v-divider></v-divider>
                        <v-row class="row-list mt-0 mb-0">
                            <v-col cols="12" class="d-flex mt-2">
                                <v-btn text @click="addOptionItem"><v-icon>mdi-plus</v-icon>Add an option</v-btn>
                                <v-btn text @click="copyOptions"><v-icon>mdi-content-copy</v-icon>Copy</v-btn>
                                <v-btn-paste text @paste="pasteOptions"></v-btn-paste>
                                <v-spacer></v-spacer>
                                <v-btn text @click="removeOptionsAll">Remove All<v-icon>mdi-delete-outline</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="row-list mt-0 mb-0">
                            <v-col cols="12" class="d-flex mt-2">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="optionListPop = false">Close</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="reasonsPop" scrollable max-width="800">
            <v-card>
                <v-card-title class="headline pb-0">Manage Rejection Reasons</v-card-title>
                <v-card-subtitle class="pb-0 pt-3 mt-0 mb-0">
                    <v-row class="row-list mt-0 mb-0">
                        <v-col sm="1" align-self="center" class="text-center">
                            <v-icon class="optionHandle">mdi-drag</v-icon>
                        </v-col>
                        <v-col sm="2" align-self="center">
                            <span class="subtitle-1 text-uppercase">ID</span>
                        </v-col>
                        <v-col sm="8" align-self="center">
                            <span class="subtitle-1 text-uppercase">Value/Text</span>
                        </v-col>
                        <v-col sm="1" align-self="center">
                            <span class="subtitle-1 text-uppercase">&nbsp;</span>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                </v-card-subtitle>
                <v-card-text style="min-height: 300px; max-height: 500px;">
                    <draggable v-model="question.Options" tag="div" handle=".optionHandle" @start="drag = true" @end="drag = false" class="d-block custom-list">
                        <v-row class="row-list v-list-item v-list-item--link theme--light mt-0 mb-0" v-for="o in item.Reasons" :key="o._id">
                            <v-col sm="1" align-self="center" class="text-center">
                                <v-icon class="optionHandle">mdi-drag</v-icon>
                            </v-col>
                            <v-col sm="2">
                                <v-text-field v-model="o._id" placeholder="Capture" hide-details single-line solo flat></v-text-field>
                            </v-col>
                            <v-col sm="8">
                                <v-text-field v-model="o.Value" placeholder="Capture" hide-details single-line solo flat></v-text-field>
                            </v-col>
                            <v-col sm="1" align-self="center" class="text-right">
                                <v-icon class="error--text" @click="removeReasonItem(o)">mdi-delete-outline</v-icon>
                            </v-col>
                        </v-row>
                    </draggable>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-container class="pt-0">
                        <v-divider></v-divider>
                        <v-row class="row-list mt-0 mb-0">
                            <v-col cols="12" class="d-flex mt-2">
                                <v-btn text @click="addReasonItem"><v-icon>mdi-plus</v-icon>Add a reason</v-btn>
                                <v-btn text @click="copyReasons"><v-icon>mdi-content-copy</v-icon>Copy</v-btn>
                                <v-btn-paste text @paste="pasteReasons"></v-btn-paste>
                                <v-spacer></v-spacer>
                                <v-btn text @click="removeReasonsAll">Remove All<v-icon>mdi-delete-outline</v-icon></v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="row-list mt-0 mb-0">
                            <v-col cols="12" class="d-flex mt-2">
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="reasonsPop = false">Close</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showRulesPop" max-width="800">
            <v-card>
                <v-card-title class="headline d-flex">
                    Manage Show Rules
                    <v-spacer></v-spacer>
                    <v-btn icon color="info" @click.stop="ruleInfoPop = true">
                        <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row class="row-list mt-2 mb-0">
                        <v-col sm="12">
                            <span class="caption ml-2 mb-4">Show rules are run before a question is shown to validate if it should be show or skipped.</span>
                        </v-col>
                    </v-row>
                    <v-simple-table fixed-header height="300">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center w-50">&nbsp;</th>
                                    <th class="text-left">Rule</th>
                                    <th class="text-center w-50">&nbsp;</th>
                                </tr>
                            </thead>
                            <draggable v-model="question.ShowRules" tag="tbody" handle=".optionHandle" @start="drag = true" @end="drag = false">
                                <tr v-for="(item, i) in question.ShowRules" :key="i">
                                    <td class="text-center"><v-icon class="optionHandle">mdi-drag</v-icon></td>
                                    <td>
                                        <v-text-field v-model="item.Value" placeholder="Capture rule" hide-details single-line solo flat></v-text-field>
                                    </td>
                                    <td class="text-center" @click="removeShowRule(i)"><v-icon class="error--text">mdi-delete-outline</v-icon></td>
                                </tr>
                            </draggable>
                            <tfoot v-if="!question.ShowRules.length"><tr><td colspan="3" class="text-center">No data.</td></tr></tfoot>
                        </template>
                    </v-simple-table>
                    <v-divider></v-divider>
                    <v-row class="row-list mt-0 mb-0">
                        <v-col cols="12" class="d-flex">
                            <v-btn text class="mt-2" @click="addShowRule"><v-icon>mdi-plus</v-icon>Add a rule</v-btn>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="showRulesPop = false">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="passRulesPop" max-width="800">
            <v-card>
                <v-card-title class="headline d-flex">
                    Manage Pass Rules
                    <v-spacer></v-spacer>
                    <v-btn icon color="info" @click.stop="ruleInfoPop = true">
                        <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row class="row-list mt-2 mb-0">
                        <v-col sm="12">
                            <span class="caption ml-2">Pass rules are run before moving to the next question to validate the answer.</span><br/>
                            <span class="caption ml-2 mb-4">One rule could match a value then jump to a further question, while another rule could prevent answer submission.</span>
                        </v-col>
                    </v-row>
                    <v-simple-table fixed-header height="300">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center w-50">&nbsp;</th>
                                    <th class="text-left">Rule</th>
                                    <th class="text-left w-200">Jump to</th>
                                    <th class="text-center w-50">&nbsp;</th>
                                </tr>
                            </thead>
                            <draggable v-model="question.PassRules" tag="tbody" handle=".optionHandle" @start="drag = true" @end="drag = false">
                                <tr v-for="(item, i) in question.PassRules" :key="i">
                                    <td class="text-center"><v-icon class="optionHandle">mdi-drag</v-icon></td>
                                    <td>
                                        <v-text-field v-model="item.Value" placeholder="Capture rule" hide-details single-line solo flat></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="item.NextId" placeholder="Optional ID" hide-details single-line solo flat></v-text-field>
                                    </td>
                                    <td class="text-center" @click="removePassRule(i)"><v-icon class="error--text">mdi-delete-outline</v-icon></td>
                                </tr>
                            </draggable>
                            <tfoot v-if="!question.PassRules.length"><tr><td colspan="3" class="text-center">No data.</td></tr></tfoot>
                        </template>
                    </v-simple-table>
                    <v-divider></v-divider>
                    <v-row class="row-list mt-0 mb-0">
                        <v-col cols="12" class="d-flex">
                            <v-btn text class="mt-2" @click="addPassRule"><v-icon>mdi-plus</v-icon>Add a rule</v-btn>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="passRulesPop = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="ratingRulesPop" max-width="800">
            <v-card>
                <v-card-title class="headline d-flex">
                    Manage Ratings
                    <v-spacer></v-spacer>
                    <v-btn icon color="info" @click.stop="ruleInfoPop = true">
                        <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row class="row-list mt-2 mb-0">
                        <v-col sm="12">
                            <span class="caption ml-2 mb-4">Set rating bands/ranges. Use the rules engine e.g. <v-chip small>@ >= 1 &amp;&amp; @ &lt;=5</v-chip> to calculate the band limits.</span>
                        </v-col>
                    </v-row>
                    <v-simple-table fixed-header height="300">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-center w-50">&nbsp;</th>
                                    <th class="text-left">Rule</th>
                                    <th class="text-left w-200">Rating Value</th>
                                    <th class="text-center w-50">&nbsp;</th>
                                </tr>
                            </thead>
                            <draggable v-model="question.RatingRules" tag="tbody" handle=".optionHandle" @start="drag = true" @end="drag = false">
                                <tr v-for="(item, i) in question.RatingRules" :key="i">
                                    <td class="text-center"><v-icon class="optionHandle">mdi-drag</v-icon></td>
                                    <td>
                                        <v-text-field v-model="item.Value" placeholder="Capture rule" hide-details single-line solo flat></v-text-field>
                                    </td>
                                    <td>
                                        <v-text-field v-model="item.Rating" placeholder="Value" hide-details single-line solo flat></v-text-field>
                                    </td>
                                    <td class="text-center" @click="removeRatingRule(i)"><v-icon class="error--text">mdi-delete-outline</v-icon></td>
                                </tr>
                            </draggable>
                            <tfoot v-if="!question.RatingRules.length"><tr><td colspan="3" class="text-center">No data.</td></tr></tfoot>
                        </template>
                    </v-simple-table>
                    <v-divider></v-divider>
                    <v-row class="row-list mt-0 mb-0">
                        <v-col cols="12" class="d-flex">
                            <v-btn text class="mt-2" @click="addRatingRule"><v-icon>mdi-plus</v-icon>Add a rule</v-btn>
                            <v-spacer></v-spacer>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="ratingRulesPop = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="autoInfoPop" max-width="800">
            <v-card dark color="info">
                <v-card-title class="headline">Auto Generated Fields</v-card-title>
                <v-card-text class="body-1 white--text" v-html="$CONST.AUTO_INFO_TEXT"></v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="autoInfoPop = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import 'quill/dist/quill.core.css';
import '../../../public/quill/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { Quill, quillEditor } from 'vue-quill-editor';
import ButtonPaste from '@/controls/ButtonPaste';
import Constants from '@/util/Constants';
import Data from '@/util/Data';
import Lexer from '@/util/Lexer';
// import mask from '@/controls/Mask';
import numeric from '@/controls/Numeric';
import * as Token from '@/util/Token.js';
import Ui from '@/util/Ui';
import Util from '@/util/Util';
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import { Camera, CameraResultType } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import { Html5QrcodeScanner } from 'html5-qrcode';
import SignaturePad from 'signature_pad';
import ImageResize from 'quill-image-resize-vue';

// Register Quill Extension for resizing capabilities
// ==================================================================
Quill.register('modules/imageResize', ImageResize);
const BaseImageFormat = Quill.import('formats/image');
const ImageFormatAttributesList = [
    'alt',
    'height',
    'width',
    'style'
];

class ImageFormat extends BaseImageFormat {
    static formats (domNode) {
        return ImageFormatAttributesList.reduce(function (formats, attribute) {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }

    format (name, value) {
        if (ImageFormatAttributesList.indexOf(name) > -1) {
            if (value) {
                this.domNode.setAttribute(name, value);
            }
            else {
                this.domNode.removeAttribute(name);
            }
        }
        else {
            super.format(name, value);
        }
    }
}
Quill.register(ImageFormat, true);
// ==================================================================
let isNameGood = false;

export default {
    name: 'SurveyEdit',
    components: {
        draggable,
        'v-btn-paste': ButtonPaste,
        // 'v-mask': mask,
        'v-numeric': numeric,
        quillEditor
    },
    mounted () {
        // this.item.Languages = ['en'];
        this.item.UpdateDate = new Date();
        this.item.UpdateDateString = this.$format.dateShortTime(this.item.UpdateDate);

        if (this.$route.query && this.$route.query.id) this.item._id = this.$route.query.id;
        this.loadLookups();

        this.lexer = new Lexer();
        /* // const str = '@=={2}||@=={6}';
        // const str = '@ == Maize';
        const str = '@ == /[^0-9]/';
        // const str = '{9}[999999/99/9] >> 15'; // PROBLEM "/"" as well as "["
        console.log(str);
        const lexer = new Lexer();
        const toks = lexer.lex(str);
        console.log(toks);
        console.log(lexer.stringFromTokens(toks)); */
    },
    data: () => ({
        isBusy: false,
        isSaving: false,
        isPublishing: false,
        isDeleting: false,
        isSurveyBusy: false,
        tagReg: /<\/?[^>]+(>|$)/g, // Remove tags from string.
        item: { // Defined the whole object otherwise the properties are not reactive.
            ProjectId: '',
            Name: '',
            Table: '',
            DashIndex: 0,
            Version: 1,
            Questions: [Data.duplicate(Constants.BLANK_QUESTION)],
            QCount: 0,
            IdCounter: 0,
            ShowStart: false,
            ShowEnd: false,
            Exposure: 'I',
            Link: '',
            Comment: '',
            UpdateDateString: '',
            OnDash: true,
            Form: false,
            Rating: false,
            RatingTotal: false,
            Once: false,
            OnceField: '',
            DashName: '',
            PopLast: false,
            PopRestrict: false,
            Approval: false,
            Reasons: [],
            RelationshipType: 'N',
            ParentRestrict: false,
            ParentId: '',
            RelationFields: [],
            Notify: false,
            NotifyEmail: '',
            Icon: '',
            Color: '#ff3a30',
            StatusId: 'A'
        },
        itemOrg: {},
        editLangIdx: 0,
        editLang: 'en', // English is the first language for this deployment.
        editLangName: 'English',
        languages: [],
        question: { Question: [{ Value: '' }], ShowRules: [], PassRules: [], RatingRules: [], Options: [], Languages: [{ id: 'en', text: 'English' }], },
        loopQuestionIds: '',
        surveyUrl: '',
        modalDate: false,
        modalTime: false,
        modalDOB: false,
        showListManButton: false,
        jumpPop: false,
        jumpText: '',
        index: 0,
        indexOne: 1,
        filterOne: '',
        filterMany: '',
        statusOptions: Constants.STATUS,
        exposureOptions: Constants.EXPOSURE,
        relationshipOptions: Constants.RELATIONSHIP_TYPE,
        numberTypeOptions: Constants.NUMBER_TYPE,
        inputTypes: [],
        iconIndex: 0,
        iconIndexActual: 0,
        iconOptions: Constants.ICON_LIST,
        iconPaged: [],
        iconPage: 1,
        iconPages: 1,
        iconPageSize: 51,
        approverOptions: [],
        surveyListOptions: [],
        surveyFieldsOptions: [],
        relationshipSurveyFields: [],
        relationshipMasterFields: [],
        relationSurveyHeaders: [
            { text: 'Order', value: 'Index', align: 'start', sortable: false },
            { text: 'Field', value: 'Field', width: '20%', sortable: false },
            { text: 'Display as', value: 'LabelTxt', width: '79%', sortable: false }
        ],
        primaryLists: [],
        selectedPrimary: null,
        showRulesPop: false,
        passRulesPop: false,
        ratingRulesPop: false,
        optionListPop: false,
        reasonsPop: false,
        ruleInfoPop: false,
        reorderPop: false,
        restrictInfoPop: false,
        colourPop: false,
        autoInfoPop: false,
        colorText: '#FFFFFF',
        editorOption: {
            modules: {
                imageResize: {},
                toolbar: [
                    [{ size: ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['image'],
                    [{ color: [] }, { background: [] }, 'clean'],
                    [{ list: 'ordered' }, { list: 'bullet' }]
                ]
            }
        },
        editorOptionMore: {
            modules: {
                imageResize: {},
                toolbar: [
                    [{ size: ['small', false, 'large', 'huge'] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    ['image'],
                    [{ color: [] }, { background: [] }, 'clean'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['blockquote', 'code-block'],
                    [{ indent: '-1' }, { indent: '+1' }],
                    [{ align: [] }]
                ]
            }
        },
        swatches: [
            ['#FF0000', '#AA0000', '#550000'],
            ['#FFFF00', '#AAAA00', '#555500'],
            ['#00FF00', '#00AA00', '#005500'],
            ['#00FFFF', '#00AAAA', '#005555'],
            ['#0000FF', '#0000AA', '#000055'],
        ],
        isValidDetail: false,
        isValidStyle: true,
        isValidMessages: true,
        isValidProperties: true,
        isValidRelationship: true,
        nameError: null,
        nameErrors: null,
        rules: {
            required: value => !!`${(value || '')}`.length || 'Required.',
            requiredInt: value => value > 0,
            min: value => (value || '').length > 1 || 'Minimum 2 characters',
            startChar: value => isNaN((value || '')[0]) || 'Must start with a character',
            avail: value => isNameGood || 'Validation required.',
        },
        inputRules: {
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || 'Invalid e-mail.';
            },
            web: value => {
                const pattern = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g;
                return pattern.test(value) || 'Invalid web address.';
            },
            mobile: value => {
                const pattern = /^(\d{3}[-])(\d{3}[-])(\d{4})$/;
                return pattern.test(value) || 'Invalid Mobile.';
            }
        },
        QrCode: ''
    }),
    methods: {
        onPrimaryChange () {
            this.selectedPrimary = this.primaryLists.find(o => o._id === this.item.ParentId);
        },
        formatValidation () {
            if (this.question.Format.toLowerCase() === 'caps') this.question.ValueStr = this.question.ValueStr.toUpperCase();
            else if (this.question.Format.toLowerCase() === 'lower') this.question.ValueStr = this.question.ValueStr.toLowerCase();
        },
        gridDataChanged () {
            this.$refs.xorGrid.forceUpdate(this.question.GridData);
        },
        updateSelect (value) {
            this.question.Answer = [value.Value];
        },
        async getQrCode (url) {
            // Get QR representation of the form link
            const res = await this.$http.get('/QrCode', { params: { qrUrl: url } });
            return res.data.d;
        },
        async updateLink () {
            let external = false;
            // console.log(this.item.Exposure.toLowerCase());
            if (this.item.Exposure.toLowerCase() === 'e') {
                external = true;
            }
            if (external === true) {
                this.item.Link = `${this.$_ROOT_APP_URL}/Survey?id=${this.item._id}&external=true`;
            }
            else {
                this.item.Link = `${this.$_ROOT_APP_URL}/Survey?id=${this.item._id}`;
            }
            const result = await this.getQrCode(this.item.Link);
            this.QrCode = '';
            if (result.imagesource !== undefined) this.QrCode = result.imagesource;
        },
        async loadLookups () {
            this.isBusy = true;
            try {
                const localInputs = await this.$db.getInputTypes(recs => { // Locally stored.
                    if (recs) this.inputTypes = recs || []; // Refresh from the server.
                });
                this.inputTypes = localInputs || [];

                // Defaults from Project.
                const p = await this.$db.getProject(this.viewProject._id);
                this.languages = [];
                p.Languages.forEach(o => {
                    const lang = Constants.LANGUAGES.find(x => x.id === o);
                    this.languages.push(lang);
                });
                if (!this.languages.length) this.languages = [{ id: 'en', text: 'English' }];
                this.item.EmailOnChange = p.EmailOnChange;
                this.item.ChangeEmail = p.ChangeEmail;
                this.item.Approval = p.Approval;
                this.item.Approver = p.Approver;
                this.item.Notify = p.Notify;
                this.item.NotifyEmail = p.NotifyEmail;
                this.item.NotifyDetail = p.NotifyDetail;
                this.iconIndex = 0;
                this.iconIndexActual = 0;

                // Users for approvers.
                /* const localRecords = await this.$db.getApprovers(this.viewProject._id, recs => { // Locally stored.
                    if (recs) this.approverOptions = recs || []; // Refresh from the server.
                });
                this.approverOptions = localRecords || []; */
                const res = await this.$http.get(`/User/approvers/${this.viewProject._id}`);
                this.approverOptions = res.data.d;

                // Other project surveys for relationship selection.
                const localSurveys = await this.$db.getSurveys(this.viewProject._id, '', { page: 1, size: 200 });
                if (!localSurveys) return;
                // Remove this survey.
                if (this.item._id) {
                    const current = localSurveys.find(o => o._id === this.item._id);
                    const pos = localSurveys.indexOf(current);
                    localSurveys.splice(pos, 1);
                }
                const data = [];
                const slen = localSurveys.length;
                for (let si = 0; si < slen; si++) {
                    const survey = localSurveys[si];
                    const len = survey.Questions.length;
                    const s = {
                        _id: survey._id,
                        Name: survey.Name,
                        Fields: []
                    };
                    for (let i = 0; i < len; i++) {
                        const q = survey.Questions[i];
                        s.Fields.push({
                            Index: q.Index,
                            Field: q.Field,
                            Question: q.Question
                        });
                    }
                    data.push(s);
                }
                this.surveyListOptions = data;

                this.iconPages = Math.ceil(this.iconOptions.length / this.iconPageSize);
                this.setIconsPage();

                // Primary lists.
                this.primaryLists = await this.$db.getPrimaries(this.viewProject._id, recs => { // Locally stored.
                    if (recs) this.tableData = recs || []; // Refresh from the server.
                    if (this.item.ParentId) {
                        this.selectedPrimary = this.primaryLists.find(o => o._id === this.item.ParentId);
                    }
                });
            }
            catch (ex) {
                console.error(ex);
                this.$error(this.$t('general.data_failed'), this.$t('general.an_error'));
            }
            finally {
                this.loadData();
            }
        },
        async loadData () {
            if (!this.item._id) {
                this.addInitialQuestion(this.item);
                this.question = this.item.Questions[this.index];
                this.isBusy = false;
                return;
            }
            this.isBusy = true;
            try {
                const d = await this.$db.getSurvey(this.item._id);
                isNameGood = true;
                this.isValidDetail = true;
                this.isValidStyle = true;
                this.isValidMessages = true;
                this.isValidProperties = true;
                this.isValidRelationship = true;
                if (!d.Questions.length) {
                    this.addInitialQuestion(d);
                }
                if (!d.Reasons) d.Reasons = [];
                Data.sort(d.Questions, 'Index');
                this.item = d;
                this.item.UpdateDateString = this.$format.dateShortTime(this.item.UpdateDate);
                await this.updateLink();
                this.iconIndexActual = this.iconOptions.indexOf(this.item.Icon);
                if (this.iconIndexActual === -1) this.iconIndexActual = 1;
                this.iconPage = Math.ceil(this.iconIndexActual / this.iconPageSize);
                this.iconIndex = this.iconIndexActual - ((this.iconPage - 1) * this.iconPageSize);
                // this.setIconsPage();// Removed this as it is already loaded
                this.itemOrg = Data.duplicate(d); // To calculate delta changes.
                this.item.Questions.forEach(o => {
                    if (o.Rules) { // Legacy fix.
                        delete o.Rules;
                        o.ShowRules = [];
                        o.PassRules = [];
                        o.RatingRules = [];
                    }
                    if (!o.RatingRules) o.RatingRules = [];
                });
                this.question = this.item.Questions[this.index];
            }
            catch (ex) {
                this.$error(this.$t('general.data_failed'), this.$t('general.an_error'));
            }
            finally {
                this.isBusy = false;
            }
        },
        async reload () {
            this.isBusy = true;
            // Reload the project surveys so that the local cache can be updated.
            // Then retrieve the survey again.
            await this.$db.getSurveys(this.viewProject._id, '', this.pager, _lastest => { // Locally stored.
                this.loadData();
            });
        },
        isBlank (value) {
            return value === '' || value === undefined || value === null;
        },
        setIconsPage () {
            this.iconIndex = -1;
            const start = (this.iconPage - 1) * this.iconPageSize;
            const end = start + this.iconPageSize;
            this.iconPaged = this.iconOptions.slice(start, end);
            if (this.iconIndexActual >= start && this.iconIndexActual <= end) {
                this.iconIndex = this.iconIndexActual - ((this.iconPage - 1) * this.iconPageSize);
                this.onIconChange();
            }
        },
        onIconChange () {
            const pagedIdx = this.iconIndex + ((this.iconPage - 1) * this.iconPageSize);
            this.iconIndexActual = pagedIdx;
            this.item.Icon = this.iconIndex === 0 ? '' : this.iconOptions[pagedIdx];
        },
        getStatusColor (id) {
            const status = Constants.STATUS.find(o => o.id === id);
            return status ? status.color : 'primary';
        },
        onInputTypeChange () {
            if (this.question.InputType === Constants.INPUT_TYPE.Image) {
                if (!this.question.Width && !this.question.Height) this.question.Width = 640;
                if (!this.question.Quality) this.question.Quality = 80;
            }
        },
        onQualityDown () {
            let newQuality = (this.question.Quality || 100) - 1;
            if (newQuality < 60) newQuality = 60;
            this.question.Quality = newQuality;
        },
        onQualityUp () {
            let newQuality = (this.question.Quality || 100) + 1;
            if (newQuality > 100) newQuality = 100;
            this.question.Quality = newQuality;
        },
        async onTakePicture () {
            const image = await Camera.getPhoto({
                quality: this.question.Quality,
                allowEditing: true,
                resultType: CameraResultType.Uri
            });

            // image.webPath will contain a path that can be set as an image src.
            // You can access the original file using image.path, which can be
            // passed to the Filesystem API to read the raw data of the image,
            // if desired (or pass resultType: CameraResultType.Base64 to getPhoto)
            const imageUrl = image.webPath;

            // Can be set to the src of an image now.
            // imageElement.src = imageUrl;
            const answer = this.question.Answer;
            answer[this.question.loopCounter || 0] = imageUrl;
            this.question.Answer = this.question.Answer.slice();
        },
        onFileLoadPhotoClick () {
            const fu = this.$refs.fileLoadPhoto.$el.querySelectorAll('input');
            fu[0].click();
        },
        onSign () {
            this.canvas = document.getElementById('user-sign');
            this.signaturePad = new SignaturePad(this.canvas, { backgroundColor: 'rgb(255, 255, 255)' });
            const canvas = this.canvas;
            const signaturePad = this.signaturePad;
            this.signaturePad.addEventListener('beginStroke', () => {
                this.answerNotValid = false;
            }, { once: true });
            this.signaturePad.addEventListener('endStroke', () => {
                this.question.ValueStr = signaturePad.toDataURL('image/jpeg');
            }, { once: true });
            function resizeCanvas () {
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvas.getContext('2d').scale(ratio, ratio);
                signaturePad.clear(); // otherwise isEmpty() might return incorrect value
            }
            window.addEventListener('resize', resizeCanvas);
            resizeCanvas();
        },
        onSignClear () {
            this.signaturePad.clear();
            this.question.ValueStr = '';
        },
        getSignatureForNext () {
            // this.signaturePad.isEmpty();
            // this.question.Answer[this.question.loopCounter || 0] = this.signaturePad.toDataURL('image/jpeg');
            this.signaturePad.off();
        },
        onFileLoadSignClick () {
            const fu = this.$refs.fileLoadSign.$el.querySelectorAll('input');
            fu[0].click();
        },
        onFileLoadChange (file) {
            const reader = new FileReader();
            reader.onload = e => {
                this.$set(this.question, 'ValueStr', e.target.result); // Use .$set to trigger the change.
            };
            reader.readAsDataURL(file); // Convert to base64 string.
        },
        async getLocation () {
            this.$set(this.question, 'Display', 'Locating...');
            this.$forceUpdate();
            const options = {
                enableHighAccuracy: true,
                timeout: (this.question.Timeout || 10) * 1000,
                maximumAge: 0

            };
            // TODO: Apply timeout in options.
            let location = {};
            if (Ui.isMac()) {
                location = await Ui.getLocation();
            }
            else {
                location = await Geolocation.getCurrentPosition(options);
            }
            this.question.ValueLat = parseFloat(location.coords.latitude.toFixed(7));
            this.question.ValueLon = parseFloat(location.coords.longitude.toFixed(7));
            this.question.ValueAcc = parseFloat(location.coords.accuracy.toFixed(2));
            this.question.ValueAccFail = location.coords.accuracy > this.question.Accuracy;
            this.question.ValueAlt = location.coords.altitude ? parseFloat(location.coords.altitude.toFixed(7)) : -1;
            // this.question.ValueSpd
            this.question.ValueArr = [this.question.ValueLon, this.question.ValueLat]; // Mongo stores ar long then lat.
            this.$set(this.question, 'ValueStr', this.$format.dmsLatLong(this.question.ValueLat, this.question.ValueLon)); // Trigger change with $set.
            /* navigator.geolocation.getCurrentPosition(location => {
                this.question.ValueLat = parseFloat(location.coords.latitude.toFixed(7));
                this.question.ValueLon = parseFloat(location.coords.longitude.toFixed(7));
                this.question.ValueAcc = location.coords.accuracy;
                this.question.ValueAccFail = location.coords.accuracy > this.question.Accuracy;
                this.question.ValueAlt = location.coords.altitude ? parseFloat(location.coords.altitude.toFixed(7)) : -1;
                // this.question.ValueSpd
                this.question.ValueArr = [this.question.ValueLon, this.question.ValueLat]; // Mongo stores ar long then lat.
                this.$set(this.question, 'ValueStr', this.$format.dmsLatLong(this.question.ValueLat, this.question.ValueLon)); // Trigger change with $set.
                // Show a map?
                // mapLink.href = `https://www.openstreetmap.org/#map=18/${latitude}/${longitude}`;
                // mapLink.textContent = `Latitude: ${latitude} °, Longitude: ${longitude} °`;
            }); */
        },
        async onScanBarcode () {
            // const answer = this.question.Answer;
            const scanner = new Html5QrcodeScanner('qr-reader', { fps: 10, qrbox: 300 });
            scanner.render((decodedText, decodedResult) => { // Success.
                this.question.ValueStr = decodedText;
                // answer[this.question.loopCounter || 0] = decodedText;
                this.$forceUpdate();
                scanner.pause();
                scanner.clear();
            }); // Ignore errors.
        },
        onSurveyChange () {
            const survey = this.surveyListOptions.find(o => o._id === this.item.ParentId);
            survey.Fields.forEach(o => {
                const lang = o.Question.find(x => x._id === this.editLang);
                o.QuestionTxt = lang.Value.replace(this.tagReg, '').substr(0, 50);
            });
            this.surveyFieldsOptions = survey.Fields;
        },
        onFieldDisplayChange () {
            // console.log(this.relationshipSurveyFields);
            if (!this.item.RelationSurveyFields) this.item.RelationSurveyFields = [];
            if (!this.relationshipSurveyFields.length) {
                this.item.RelationSurveyFields = [];
                return;
            }
            const fields = [];
            const survey = this.surveyListOptions.find(o => o._id === this.item.ParentId);
            this.relationshipSurveyFields.forEach((o, i) => {
                const q = survey.Fields.find(x => x.Field === o);
                const rec = {
                    Index: i + 1,
                    Field: o,
                    Label: []
                };
                const lang = q.Question.find(x => x._id === this.editLang);
                rec.Label[this.editLang] = lang.Value.replace(this.tagReg, '');
                rec.LabelTxt = rec.Label[this.editLang];
                fields.push(rec);
            });
            this.item.RelationSurveyFields = fields;
        },
        onBlur () {
            const name = this.item.Name || '';
            if (!this.item._id && name.length) {
                const pre = Util.nameToTableShort(name);
                // Append a number, if none.
                this.item.Table = `__${pre}_0001`;
                // Check the database.
                this.isSurveyBusy = true;
                this.checkSurveyName();
            }
        },
        async checkSurveyName () {
            this.isSurveyBusy = true;
            try {
                const res = await this.$http.get(`/Survey/available/${this.item.Name}`);
                const d = res.data.d;
                isNameGood = d.Name === null; // There is no exact name in the DB.
                this.nameError = !isNameGood;
                this.nameErrors = isNameGood ? null : 'This form name is already taken!';
                this.item.Table = `__${this.viewProject.Prefix}_${d.Table}`; // Server suggested table name.
                this.$refs.formDetail.validate();
            }
            catch (ex) {
                this.$error(this.$t('general.data_failed'), this.$t('general.an_error'));
            }
            finally {
                this.isSurveyBusy = false;
            }
        },
        addInitialQuestion (rec) {
            const q = Data.duplicate(Constants.BLANK_QUESTION);
            q.Question[this.editLangIdx]._id = this.editLang;
            q._id = 1;
            q.Field = `F${q._id}`;
            rec.IdCounter = 1;
            rec.QCount = 1;
            rec.Questions = [q];
        },
        addQuestion () {
            const q = Data.duplicate(Constants.BLANK_QUESTION);
            q.Index = this.item.Questions.length + 1;
            this.item.IdCounter += 1;
            q._id = this.item.IdCounter;
            q.Field = `F${q._id}`;
            this.item.Questions.push(q);
            this.item.QCount = this.item.Questions.length;
            this.index = this.item.Questions.length - 1;
        },
        onOrderEnd (data) {
            this.reIndexQuestions();
            return true;
        },
        onLanguageChange (item) {
            // Language code.
            const lang = item.id;
            // Check if the selected language has question text for each question.
            const missingIdx = [];
            const missing = [];
            // Gather missing question text.
            this.item.Questions.forEach((q, i) => {
                const langQ = q.Question.find(o => o._id === lang);
                if (!langQ || !langQ.Value) {
                    missingIdx.push(i);
                    missing.push(q.Question[0].Value); // Add the main language text.
                    if (!langQ) {
                        q.Question.push({ _id: lang, Value: '' }); // Add blank question text placeholder to prevent UI errors.
                    }
                }
            });
            // Set props to update the UI.
            // Find the new index position for the current question for the newly selected language.
            const langQ = this.question.Question.find(o => o._id === lang);
            this.editLangIdx = this.question.Question.indexOf(langQ);
            this.editLang = item.id;
            this.editLangName = item.text;
            // Ask the user to attempt translation.
            if (missing.length) {
                const optionItems = [
                    'Missing/blank values only',
                    'Translate all the questions even if they already have text',
                    'Cancel - Do not translate anything'
                ];
                const options = {
                    title: 'Missing Translations',
                    message: `There are questions that have not yet been translated to ${this.editLangName}. Would you like the system to attempt auto-translation and populate them?`,
                    options: optionItems,
                    value: ''
                };
                this.$prompt(options, async value => {
                    if (value.Action) {
                        const pos = optionItems.indexOf(value.Value);
                        if (pos === 2) return;
                        this.$process({ show: true, message: 'Translating ...' });
                        const res = await this.$http.get(`/Survey/${this.item._id}/translate/${lang}/all`); // ${pos === 0 ? 'all' : idx}
                        if (res.data.s) {
                            const d = res.data.d;
                            d.missingIdx.forEach((idx, i) => {
                                try {
                                    const q = this.item.Questions.find(o => o.Index === idx);
                                    const langQ = q.Question.find(o => o._id === d.lang);
                                    langQ.Value = d.translations[i];
                                }
                                catch (ex) {
                                    console.error(ex);
                                }
                            });
                        }
                        else this.$error(this.$t('general.delete_error'), this.$t('general.an_error'));
                        this.$process({ show: false });
                    }
                });
            }
        },
        copyLink () {
            this.$copyText(this.item.Link).then(e => {
                this.$info('Copied', 'The form URL was copied to the clipboard.', 2);
            }, () => {
                this.$error('Copy Error', 'Unable to the clipboard.');
            });
        },
        showInputType (typeId) {
            // return typeId === this.item.Questions[this.index].InputType;
            return typeId === this.question.InputType;
        },
        showOption (fieldId) {
            const input = this.inputTypes.find(o => o._id === this.item.Questions[this.index].InputType);
            if (!input) return false; // No such input.
            if (fieldId === -1 && !input.Options.length) return true; // Check the info display when there are no options.
            const hasIt = input.Options.indexOf(fieldId) > -1;
            if (hasIt && fieldId === Constants.INPUT.Format && this.item.Questions[this.index].Lines > 1) return false; // Special case.
            return hasIt;
        },
        // Options.
        addOptionItem () {
            const len = this.item.Questions[this.index].Options.length;
            const opt = {
                _id: len === 0 ? 1 : Math.max(...this.item.Questions[this.index].Options.map(o => o._id)) + 1,
                Value: '',
                Lang: this.editLang,
                Index: len
            };
            this.item.Questions[this.index].Options.push(opt);
        },
        removeOptionItem (opt) {
            const pos = this.item.Questions[this.index].Options.indexOf(opt);
            this.item.Questions[this.index].Options.splice(pos, 1);
        },
        removeOptionsAll () {
            this.item.Questions[this.index].Options = [];
        },
        copyOptions () {
            // const list = this.question.Options.map(o => [o._id, o.Value, o.Lang, o.Index, o.Parent]);
            // const text = JSON.stringify(list);
            const data = this.question.Options.map(o => [o.Lang, o._id, o.Value, o.Index, o.Parent].join('\t'));
            const text = data.join('\n');
            Ui.clipboardSet(text).then(e => {
                this.$info('Copied', 'The Option list was copied to the clipboard.', 2);
            }).catch(ex => {
                this.$error('Copy Error', ex.message);
            });
        },
        pasteOptions (data) {
            const options = Data.duplicate({ d: this.question.Options }).d;
            const lines = data.replace(/\r/g, '').split('\n');
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                const vals = line.split('\t');
                let opt = {};
                const len = options.length;
                const newId = len === 0 ? 1 : Math.max(...options.map(o => o._id)) + 1;
                if (vals.length === 1) {
                    opt = {
                        Lang: this.editLang,
                        _id: newId,
                        Value: vals[0],
                        Index: len
                    };
                }
                else if (vals.length === 2) {
                    opt = {
                        Lang: vals[0],
                        _id: newId,
                        Value: vals[1],
                        Index: len
                    };
                }
                else if (vals.length === 5) {
                    opt = {
                        Lang: vals[0],
                        _id: vals[1],
                        Value: vals[2],
                        Index: vals[3],
                        Parent: vals[4]
                    };
                }
                else {
                    opt = {
                        Lang: vals[0],
                        _id: newId,
                        Value: vals[1],
                        Index: len,
                        Parent: vals[2]
                    };
                }
                options.push(opt);
            }
            this.question.Options = options;
        },
        // Rules.
        addShowRule () {
            this.question.ShowRules.push({
                _id: 0,
                Value: ''
            });
        },
        removeShowRule (index) {
            this.question.ShowRules.splice(index, 1);
        },
        addPassRule () {
            this.question.PassRules.push({
                _id: 0,
                Value: '',
                NextId: ''
            });
        },
        removePassRule (index) {
            this.question.PassRules.splice(index, 1);
        },
        addRatingRule () {
            this.question.RatingRules.push({
                _id: 0,
                Value: '',
                Rating: 1
            });
        },
        removeRatingRule (index) {
            this.question.RatingRules.splice(index, 1);
        },
        // Rejection reasons.
        addReasonItem () {
            const len = this.item.Reasons.length;
            const o = {
                _id: len === 0 ? 1 : Math.max(...this.item.Reasons.map(o => o._id)) + 1,
                Value: '',
                Lang: this.editLang,
                Index: len
            };
            this.item.Reasons.push(o);
        },
        removeReasonItem (o) {
            const pos = this.item.Reasons.indexOf(o);
            this.item.Reasons.splice(pos, 1);
        },
        removeReasonsAll () {
            this.item.Reasons = [];
        },
        copyReasons () {
            // const list = this.item.Reasons.map(o => [o._id, o.Value, o.Lang, o.Index, o.Parent]);
            // const text = JSON.stringify(list);
            const data = this.item.Reasons.map(o => [o.Lang, o._id, o.Value, o.Index].join('\t'));
            const text = data.join('\n');
            Ui.clipboardSet(text).then(e => {
                this.$info('Copied', 'The Reasons list was copied to the clipboard.', 2);
            }).catch(ex => {
                this.$error('Copy Error', ex.message);
            });
        },
        pasteReasons (data) {
            const reasons = Data.duplicate({ d: this.item.Reasons }).d;
            const lines = data.replace(/\r/g, '').split('\n');
            for (let i = 0; i < lines.length; i++) {
                const line = lines[i];
                const vals = line.split('\t');
                let opt = {};
                const len = reasons.length;
                const newId = len === 0 ? 1 : Math.max(...reasons.map(o => o._id)) + 1;
                if (vals.length === 1) {
                    opt = {
                        Lang: this.editLang,
                        _id: newId,
                        Value: vals[0],
                        Index: len
                    };
                }
                else if (vals.length === 4) {
                    opt = {
                        Lang: vals[0],
                        _id: newId,
                        Value: vals[2],
                        Index: len
                    };
                }
                else {
                    opt = {
                        Lang: vals[0],
                        _id: newId,
                        Value: vals[1],
                        Index: len
                    };
                }
                reasons.push(opt);
            }
            this.item.Reasons = reasons;
        },
        // Question navigation.
        jumpChange (evt) {
            if (evt.key === 'Enter') {
                const idx = parseInt(this.jumpText, 10);
                if (isNaN(idx)) return;
                this.jumpPop = false;
                this.$nextTick(() => {
                    this.onJump(idx);
                });
            }
            else if (evt.key === 'Escape') {
                this.jumpPop = false;
            }
        },
        onJump (idx) {
            const q = this.item.Questions.find(o => o.Index === idx);
            if (q) {
                this.index = this.item.Questions.indexOf(q);
                this.indexOne = this.index + 1;
            }
            else {
                this.$warning('Not Found', `There is no question at index ${idx}.`);
            }
        },
        onPrevious () {
            if (this.index < 1) return;
            this.filterOne = '';
            this.filterMany = '';
            this.index -= 1;
        },
        onNext () {
            this.filterOne = '';
            this.filterMany = '';
            if (this.index >= this.item.Questions.length - 1) return;
            this.index += 1;
        },
        // Main button actions.
        async onSave (evt) {
            const forPreview = evt === true;
            this.$refs.formDetail.validate();
            if (this.$refs.formStyle) this.$refs.formStyle.validate(); // Don't run if not initialised.
            if (this.$refs.formMessages) this.$refs.formMessages.validate(); // Don't run if not initialised.
            if (this.$refs.formProperties) this.$refs.formProperties.validate(); // Don't run if not initialised.
            if (this.$refs.formRelationship) this.$refs.formRelationship.validate(); // Don't run if not initialised.
            if (this.isValidDetail && this.isValidStyle && this.isValidMessages && this.isValidProperties && this.isValidRelationship) {
                const delta = Data.delta(this.itemOrg, this.item); // Only the changed fields.
                if (delta) {
                    try {
                        this.isSaving = true;
                        let res = null;
                        if (this.item._id) { // Update.
                            if (this.item.Version === this.item.PublishedVer) delta.Version = this.item.Version + 1;
                            res = await this.$http.put(`/Survey/${this.item._id}`, delta);
                            // Update the dashboard record.
                            if (delta.Icon || delta.Color) {
                                await this.$http.put(`/Dashboard/${this.item._id}`, {
                                    Name: this.item.DashName || this.item.Name,
                                    Color: this.item.ColorOn ? (this.item.Color || 'accent') : '#FFFFFF',
                                    Icon: this.item.Icon,
                                });
                            }
                        }
                        else { // Add.
                            delta.ProjectId = this.viewProject._id;
                            res = await this.$http.post('/Survey', delta);
                            // Add a new dashboard record.
                            await this.$http.post('/Dashboard', {
                                _id: res.data.d,
                                ProjectId: this.viewProject._id,
                                Name: this.item.DashName || this.item.Name,
                                Count: 0,
                                Color: this.item.ColorOn ? (this.item.Color || 'accent') : '#FFFFFF',
                                Icon: this.item.Icon,
                                Version: this.item.Version
                            });
                        }
                        if (res.data.s) {
                            this.$root.$emit('SRVY_SurveyUpdate', { _id: this.item._id || res.d, Name: this.item.Name, Icon: this.item.Icon, StatusId: this.item.StatusId, Form: this.item.Form });
                            if (!forPreview) this.onCancel();
                        }
                        else this.$error(this.$t('general.save_error'), this.$t('general.an_error'));
                    }
                    catch (ex) {
                        this.$error(this.$t('general.save_error'), this.$t('general.an_error'));
                    }
                    finally {
                        this.isSaving = false;
                    }
                }
                else if (!forPreview) this.onCancel(); // Nothing was changed. Nav back.
            }
        },
        async onPreview () {
            await this.onSave(true);
            this.$router.push({ name: `Survey${this.item.Form ? 'Form' : 'Act'}`, query: { id: this.item._id, preview: true } });
        },
        reIndexQuestions () {
            // Re-index the questions.
            this.item.Questions.forEach((o, i) => {
                o.OldIndex = o.Index;
                o.Index = i + 1;
            });
            // Update the rules. Loop all the questions' rules.
            this.item.Questions.forEach(o => {
                o.ShowRules.forEach(r => {
                    // console.log(JSON.stringify(r));
                    this.checkIndexOnRule(r);
                });
                o.PassRules.forEach(r => {
                    // console.log(JSON.stringify(r));
                    this.checkIndexOnRule(r);
                });
                o.RatingRules.forEach(r => {
                    // console.log(JSON.stringify(r));
                    this.checkIndexOnRule(r);
                });
            });
            // Remove the old index value.
            this.item.Questions.forEach(o => {
                delete o.OldIndex;
            });
        },
        checkIndexOnRule (rule) {
            const toks = this.lexer.lex(rule.Value);
            let nextDone = false;
            this.item.Questions.forEach(o => {
                if (!nextDone && rule.NextId === o.OldIndex) {
                    rule.NextId = o.Index;
                    nextDone = true;
                }
                const oldI = `{${o.OldIndex}}`;
                const newI = `{${o.Index}}`;
                for (const tok of toks) {
                    if (!tok.done && tok.type === Token.TYPE.Range && tok.value === oldI) {
                        tok.value = newI;
                        tok.done = true;
                    }
                }
            });
            rule.Value = this.lexer.stringFromTokens(toks);
        },
        onPublish () {
            this.$confirm({ title: `Publish v${this.item.Version}?`, message: 'Are you sure you want to publish the latest version of the survey?\nDoing so will allow whomever has access to it, to submit answers using this new version.', value: `Version ${this.item.Version}` }, async yes => {
                if (!yes) return;
                await this.onSave(true);
                this.isPublishing = true;
                try {
                    const res = await this.$http.get(`/Survey/${this.item._id}/publish`);
                    if (res.data.s) {
                        this.$success('Success', `Version ${this.item.Version} was successfully published.`);
                        this.$root.$emit('SRVY_SurveyUpdate', {});
                        this.reload();
                    }
                    else this.$error(this.$t('general.delete_error'), this.$t('general.an_error'));
                }
                catch (ex) {
                    this.$error(this.$t('general.save_error'), this.$t('general.an_error'));
                }
                finally {
                    this.isPublishing = false;
                }
            });
        },
        onDuplicate () {
            //
        },
        onRemoveQuestion (questionId) {
            if (questionId === undefined) questionId = this.question._id;
            const q = this.item.Questions.find(o => o._id === questionId);
            const pos = this.item.Questions.indexOf(q);
            const lastIdx = this.item.Questions.length - 1;
            if (pos >= lastIdx) this.index = lastIdx - 1; // Deleting the last question. Move 1 back.
            this.item.Questions.splice(pos, 1);
            this.reIndexQuestions();
        },
        async onDelete () {
            try {
                this.isDeleting = true;
                const res = await this.$http.delete(`/Survey/${this.item._id}`);
                if (res.data.s) {
                    const d = res.data.d;
                    if (d.deleted) {
                        this.$root.$emit('SRVY_SurveyUpdate', { _id: this.item._id || res.d, Name: this.item.Name, Icon: this.item.Icon, StatusId: this.item.StatusId, Form: this.item.Form });
                        this.onCancel();
                    }
                    else {
                        const optionItems = [
                            'Delete form and keep the answers (Form & Dashboard)',
                            'Delete form and ALL DATA (Form, Answers & Dashboard)',
                            'Only set form status to Hidden',
                            'Cancel. Do not delete anything'
                        ];
                        const options = {
                            title: 'Delete Answers & All Data?',
                            message: `This form has answers captured against it. If you choose to delete all data, ${d.answers} answers will be deleted and is permanent! Please note that you can hide a form from the Dashboard display by setting its status to Hidden.`,
                            options: optionItems,
                            value: ''
                        };
                        this.$prompt(options, async value => {
                            if (value.Action) {
                                // 'rem-data'
                                const pos = optionItems.indexOf(value.Value);
                                if (pos < 0 || pos > 2) return;
                                const res = await this.$http.delete(`/Survey/${this.item._id}?all-data=${pos}`);
                                if (res.data.s) {
                                    this.$root.$emit('SRVY_SurveyUpdate', { _id: this.item._id || res.d, Name: this.item.Name, Icon: this.item.Icon, StatusId: this.item.StatusId, Form: this.item.Form });
                                    this.onCancel();
                                }
                                else this.$error(this.$t('general.delete_error'), this.$t('general.an_error'));
                            }
                        });
                    }
                }
                else this.$error(this.$t('general.delete_error'), this.$t('general.an_error'));
            }
            catch (ex) {
                this.$error(this.$t('general.save_error'), this.$t('general.an_error'));
            }
            finally {
                this.isDeleting = false;
            }
        },
        onCancel () {
            this.$router.go(-1);
        }
    },
    watch: {
        index () {
            this.indexOne = this.index + 1;
            // Get the question at this index.
            const q = this.item.Questions.find(o => o.Index === this.indexOne);
            if (q) {
                // Find the question text value index for the selected language.
                const langQ = q.Question.find(o => o._id === this.editLang);
                this.editLangIdx = q.Question.indexOf(langQ);
            }
            else this.editLangIdx = -1;
            this.question = q;
        },
        indexOne (val) { // Triggered by the slider.
            this.index = val - 1;
            // Get the question at this index.
            const q = this.item.Questions.find(o => o.Index === this.indexOne);
            if (q) {
                // Find the question text value index for the selected language.
                const langQ = q.Question.find(o => o._id === this.editLang);
                this.editLangIdx = q.Question.indexOf(langQ);
            }
            else this.editLangIdx = -1;
            this.question = q;
        },
        modalDOB (val) {
            val && setTimeout(() => (this.$refs.previewDOB.activePicker = 'YEAR'));
        },
        jumpPop (val) {
            if (!val) this.jumpText = '';
        },
        itemColor (val) {
            this.colorText = Util.getContrast(this.item.Color);
        },
        viewProject () {
            this.$router.push({ name: 'SurveyList' });
        }
    },
    computed: {
        itemColor () {
            return this.item.Color;
        },
        optionsOne () {
            if (this.question.Filter) {
                return this.question.Options.filter(o => o.Lang === this.editLang && o.Value.toLocaleLowerCase().startsWith(this.filterOne.toLocaleLowerCase())).slice(0, 20);
            }
            else {
                return this.question.Options;
            }
        },
        optionsMany () {
            if (this.question.Filter) {
                return this.question.Options.filter(o => o.Lang === this.editLang && o.Value.toLocaleLowerCase().startsWith(this.filterMany.toLocaleLowerCase())).slice(0, 20);
            }
            else {
                return this.question.Options;
            }
        },
        ...mapState({
            viewProject: 'viewProject'
        })
    }
};
</script>

<style>
.preview-box {
    background-color: #FEFEFE;
    border: 1px solid #F0F0F0 !important;
    min-height: 300px;
    max-height: 600px;
    overflow-y: auto;
}
.quill-editor .ql-container {
    font-size: 12pt;
}
.editor-larger .ql-container {
    min-height: 200px;
}
</style>
